import uuid from 'uuid'
import Vue from 'vue'
import { getField, updateField } from 'vuex-map-fields'
import axios from 'axios'
import Banners from '../services/api/Banners'

const LANGUAGES = ['en', 'es']
const IMAGE_TRANSFORM_MAP = {
  image: '320X50@2x',
  imageTabletLandscape: '970X90@2x',
  imageTabletPortrait: '720X90@2x',
}

const getDataFromStorage = async () => {
    try {
        return await Banners.getBanners()
    } catch (e) {
        return undefined
    }
}

export default {
  namespaced: true,
  state: {
    locale: 'en',
    platform: 'ios',
    device: 'phone',
    bannersOrder: [],
    banners: {},
  },
  getters: {
    getField,
    state: (state) => state,
    model: (state) => {
      const { banners = {}, bannersOrder = [] } = state
      const output = {}

      LANGUAGES.forEach((language) => {
        output[language] = {
          banners: bannersOrder.reduce((arr, id) => {
            const banner = Object.assign({}, banners[id])

            if (banner.locale !== language) {
              return arr
            }

            Object.keys(IMAGE_TRANSFORM_MAP).forEach((key) => {
              const publicIdKey = `${key}PublicId`

              if (!banner[`${key}HBImage`] && banner[publicIdKey]) {
                banner[key] = banner[publicIdKey]
              }
            })

            return arr.concat(banner)
          }, []),
        }
      })

      return output
    },
    paths: (_, getters) => Object.keys(getters.model).map((path) => `atbatconfig/banners/${path}/mlb.json`),
    banners: (state) => state.banners,
    bannersOrder: (state) => state.bannersOrder,
    bannersOrdered: (state) => state.bannersOrder.map((id) => state.banners[id]),
  },
  mutations: {
    updateField,
    addBanner(state) {
      const id = uuid.v4()
      const { locale, bannersOrder, banners } = state

      Vue.set(banners, id, {
        id,
        locale,
        ios: true,
        android: true,
        paid: true,
        lite: true,
        phone: true,
        tablet: true,
        appVersion: '',
        osVersion: '',
        entitlement: '',
        accessFeature: '',
        screen: '',
        viewid: '',
        type: '',
        title: id,
        webviewtype: '4',
        image: '',
        imageTabletLandscape: '',
        imageTabletPortrait: '',
        closable: true,
        link: '',
        backgroundColor: '',
        trackingString: '',
        adMarvelId: '',
        adMarvelMLBTarget: '',
        adMarvelWidth: '',
        adMarvelHeight: '',
        adMarvelSectionId: '',
        admarvelExpiryTimeInSec: '',
        contentID: '',
        calendarEventID: '',
        requiresAuthentication: false,
        sponsor: '',
        animate: false,
      })

      bannersOrder.push(id)
    },
    removeBanner(state, { id }) {
      const index = state.bannersOrder.indexOf(id)

      if (index >= 0) {
        delete state.banners[id]
        state.bannersOrder.splice(index, 1)
      }
    },
    setBannersData(state, data) {
      state.banners = data.banners
      state.bannersOrder = data.bannersOrder
    },
    updateBannersOrder(state, newOrder) {
      state.bannersOrder = newOrder
    },
    updateBanner(state, { id, field, value }) {
      const banner = state.banners[id]

      delete banner[`${field}HBImage`]

      banner[field] = value
    },
  },
  actions: {
    async loadBannersData({ commit }) {
      const state = {
        banners: {},
        bannersOrder: [],
      }

      const bannersFromStorage = await getDataFromStorage()

      if (bannersFromStorage) {
        return commit('setBannersData', bannersFromStorage)
      }

      await Promise.all(
        ['en', 'es'].map(async (locale) => {
          const response = await axios.get(
            `https://betacontent.mlb.com/app/mlb/mobile/gen/hb/list/atbat/${locale}/device-banners.json`,
          )
          const { banners = [] } = response.data || {}

          const ids = banners.map((banner) => banner.id || uuid.v4())

          banners.forEach((banner, index) => {
            const id = ids[index]

            banner.locale = locale
            banner.title = banner.title || id

            Object.keys(IMAGE_TRANSFORM_MAP).forEach((key) => {
              if (banner[key]) {
                banner[`${key}HBImage`] = true
              }
            })

            state.banners[id] = banner
          })

          state.bannersOrder = state.bannersOrder.concat(ids)
        }),
      )

      return commit('setBannersData', state)
    },
  },
}
